// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"2011":"f9dd9dcf330b7f6f","5174":"c96cda015e7a304d","5736":"f9dd9dcf330b7f6f"}[chunkId] + ".css";
};